import * as React from 'react';
import BaseTable from '@/components/bases/BaseTable';
import { useNavigate } from 'react-router-dom';
import MemberTable from '@/screens/Family/components/MemberTable';
import utils from '@/utils';
import { TableColumnsType } from 'antd';
import useQueries from '@/hooks/useQueries';
import i18n from '@/utils/translations/i18n';

export interface IFamilyTableProps {
  total: number;
  data: any[];
  searchHandler?: Function;
}

const expandedRowRender = (data: any) => {
  const expandedData = (data?.members || [])
    .map((d: any) => ({ ...d, key: d._id }))
    .filter((m: any) => m._id !== data.protector._id);

  return <MemberTable data={expandedData} />;
};

export default function FamilyTable(props: IFamilyTableProps) {
  const navigate = useNavigate();
  const ref = React.useRef(null);
  const [expandedKeys, setExpandedKeys] = React.useState<number[]>([]);
  const [queries] = useQueries();
  const { page = 1, limit = 20 } = queries;

  const { data, total } = props;

  React.useEffect(() => {
    setExpandedKeys([]);
  }, [data]);
  React.useEffect(() => {
    const element: any = ref.current;
    const active = element.querySelector(`[data-row-key="${expandedKeys[0]}"]`);

    Array.from(element.querySelectorAll('.row-family-table')).map((e: any) => {
      e.style.background = 'inherit';
    });

    if (active) {
      active.style.background = '#e7faFA';
    }
  }, [expandedKeys]);

  return (
    <div className="h-full w-full overflow-auto" ref={ref}>
      <BaseTable
        rowClassName={'row-family-table'}
        fullscreen
        className="[&_tr]:cursor-pointer h-[100px]"
        size="middle"
        columns={columns}
        onRow={(record) => ({
          onClick: () => {
            navigate(`/phr/${record?.protector?._id}`);
          },
        })}
        expandable={{
          expandedRowRender,
          expandedRowKeys: expandedKeys,
          onExpandedRowsChange(keys) {
            setExpandedKeys([[...keys].pop()] as number[]);
          },
          showExpandColumn: true,
          expandIcon: ({ expanded, onExpand, record }) => {
            return record?.members?.length ? (
              <span
                className="cursor-pointer"
                onClick={(e: any) => {
                  e.stopPropagation();
                  return onExpand(record, e);
                }}
              >
                {expanded ? (
                  <img src="/icons/Regular/Caret up - icon.svg" alt="" />
                ) : (
                  <img src="/icons/Regular/Caret down - icon.svg" alt="" />
                )}
              </span>
            ) : (
              ''
            );
          },
        }}
        dataSource={data}
        pagination={{
          className: 'sticky bottom-0 left-0 bg-white p-2',
          showTotal: (totalRecord, range) => `${range[0]}-${range[1]} / ${totalRecord} ${i18n.t('common.record')}`,
          total: total,
          showSizeChanger: true,
          defaultPageSize: 20,
          defaultCurrent: 1,
          pageSize: Number(limit),
          current: Number(page),
          onChange(page, limit) {
            props?.searchHandler &&
              props?.searchHandler((queries: any) => ({
                ...queries,
                page,
                limit,
              }));
          },
        }}
      />
    </div>
  );
}

const columns: TableColumnsType<any> = [
  {
    width: '20%',
    title: 'Mã gia đình',
    dataIndex: 'code',
    key: 'code',
    className: 'font-bold',
  },
  {
    width: '20%',
    title: 'Đại diện gia đình',
    dataIndex: ['protector', 'username'],
    key: 'protector',
    className: 'font-bold',
  },
  {
    width: '20%',
    title: 'Số điện thoại',
    dataIndex: ['protector', 'phone'],
    key: 'phone',
    className: 'font-bold',
  },
  {
    width: '20%',
    title: 'Ngày sinh',
    dataIndex: ['protector', 'birthday'],
    key: 'birthday',
    className: 'font-bold',
    render(value) {
      return utils.safeFormat(value);
    },
  },
  {
    width: '20%',
    title: 'Số lượng thành viên',
    dataIndex: ['members', 'length'],
    key: 'members',
    className: 'font-bold',
    render(value) {
      return Number(value) + 1;
    },
  },
];
